function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
// import { isNotDisconnectableDataSource } from 'helpers/externalDataSources';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import App from 'modules/App';
import { CONNECT_DATA_SOURCE_MODAL, CONNECT_DATA_SOURCE_FORM } from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import styles from './ExternalDataSource.pcss';
const ConnectionStatus = ({ externalDataSource })=>{
    const { externalDataSourceId } = externalDataSource;
    const connectedDataSources = useSelector(selectors.connectedDataSources);
    const openConnectDataSourceModal = useAction(App.actions.openModal, CONNECT_DATA_SOURCE_MODAL);
    const setConnectDataSourceFormContext = useAction(App.actions.setFormContext, CONNECT_DATA_SOURCE_FORM);
    if (!connectedDataSources) {
        return null;
    }
    const connectedDataSource = connectedDataSources.find((cds)=>cds.externalDataSourceId === externalDataSourceId);
    const isConnected = !!connectedDataSource;
    // if (connectedDataSource) {
    //   const isNotDisconnectable = isNotDisconnectableDataSource(externalDataSource);
    //   return (
    //     <div className={styles.dataSource__status}>
    //       <div className="tag tag--success"><FormattedMessage {...messages.tags.connected} /></div>
    //       <Button
    //         isDisabled={isNotDisconnectable}
    //         styleModifier="quaternary"
    //         labelMessage={messages.buttons.disconnect}
    //         className={cn('btn--sm px-4 mx-3', { 'text--primary': !isNotDisconnectable })}
    //         // isInProgress={isDisconnectInProgress}
    //         // onClick={() => onDisconnect(connectedDataSource.accountExternalDataSourceId)}
    //       />
    //     </div>
    //   );
    // }
    const onConnect = ()=>{
        setConnectDataSourceFormContext({
            externalDataSource
        });
        openConnectDataSourceModal();
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.dataSource__status,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: `tag tag--${isConnected ? 'success' : 'error'}`,
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.tags[isConnected ? 'connected' : 'notConnected']))
            }),
            /*#__PURE__*/ _jsx(Button, {
                styleModifier: "quaternary",
                labelMessage: messages.buttons[isConnected ? 'reauthorize' : 'connect'],
                className: "btn--sm px-4 mx-3 text--primary",
                // isInProgress={isConnectInProgress}
                onClick: onConnect
            })
        ]
    });
};
export default ConnectionStatus;
